function toggleCart(doClose = false) {
  const drawer = document.querySelector("#cart-drawer");
  if (!drawer.classList.contains("is-drawer-open") && !doClose) {
    drawer.classList.add("is-drawer-open");
    drawer.classList.add("is-open");
    document.body.style.overflow = "hidden";
    document
      .querySelectorAll(['[data-animation="cart-items-fade"]'])
      .forEach((item) => {
        item.classList.add("is-animated");
      }, 50);
  } else {
    drawer.classList.add("is-closing");
    document.body.style.overflow = "";
    document
      .querySelectorAll(['[data-animation="cart-items-fade"]'])
      .forEach((item) => {
        item.classList.remove("is-animated");
      }, 50);
    setTimeout(() => {
      drawer.classList.remove("is-drawer-open");
      drawer.classList.remove("is-closing");
      drawer.classList.remove("is-open");
    }, 300);
  }
}

let upgradeFromVariantId = "";
let upgradeBlock = null;

function bodyOverflow() {
  setTimeout(() => {
    document.body.style.overflow = "hidden";
  }, 500);
  window.removeEventListener("transitionend", bodyOverflow);
}

function fetchCart() {
  fetch("/cart?section_id=api-cart-drawer")
    .then((response) => response.text())
    .then((response) => {
      document.querySelector("#cart-drawer").classList.remove("is-loading");

      document
        .querySelector("#cart-drawer")
        .querySelector(".drawer-cart__inner").innerHTML = new DOMParser()
        .parseFromString(response, "text/html")
        .querySelector(".drawer-cart__inner").innerHTML;

      setTimeout(() => {
        toggleCart();
      }, 0);

      document
        .querySelector("checkout-btn")
        ?.classList.remove("free-gift-loading");
      document
        .querySelector("#addToCart")
        ?.classList.remove("free-gift-loading");
      document
        .querySelectorAll(".free-gift-loading")
        .forEach((item) => item.classList.remove("free-gift-loading"));
    });

  fetch("/cart.js")
    .then((response) => response.json())
    .then((response) => {
      document.querySelectorAll("cart-counter").forEach((item) => {
        let count = response.item_count;
        const protectionId = Number(
          item.getAttribute("data-order-protection-id")
        );

        for (const item of response.items) {
          if (item.product_id === protectionId) {
            count--;
          }
        }
        item.updateCount(count);
      });
    });
}

document.addEventListener("DOMContentLoaded", () => {
  let adding = false;

  document
    .querySelectorAll(["[data-cart-toggle]", ".continue-shopping"])
    .forEach((item) =>
      item.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        toggleCart();
      })
    );

  document
    .querySelector("#cart-drawer .drawer-cart__underlay")
    .addEventListener("click", () => {
      toggleCart(true);
    });

  if (!customElements.get("order-protection")) {
    customElements.define(
      "order-protection",
      class OrderProtection extends HTMLElement {
        constructor() {
          super();

          const btn = this.querySelector("a");
          const cartJson = JSON.parse(
            this.querySelector("#cart-json").innerHTML
          );

          if (localStorage.getItem("order-user-cancel")) {
            let index;
            for (const item of cartJson.items) {
              if (item.product_id === Number(this.getAttribute("data-id"))) {
                if (this.getAttribute("data-enabled") === "true") {
                  btn.classList.add("active");
                } else {
                  CartJS.removeItemById(btn.getAttribute("data-id"));
                }
              }
              index += 1;
            }
          } else {
            const isOrderInCart = cartJson.items.find(
              (item) => item.product_id === Number(this.getAttribute("data-id"))
            );
            if (!isOrderInCart && btn.getAttribute("data-id")) {
              window.noCartRefresh = true;
              btn.classList.add("active");
              CartJS.addItem(btn.getAttribute("data-id"));
            } else if (isOrderInCart) {
              btn.classList.add("active");
            }
          }

          btn.addEventListener("click", () => {
            if (window.noCartRefresh) {
              return;
            }

            btn.classList.toggle("active");
            document
              .querySelector("checkout-btn")
              .classList.add("free-gift-loading");
            window.noCartRefresh = true;
            if (this.querySelector("a").classList.contains("active")) {
              CartJS.addItem(btn.getAttribute("data-id"));
            } else {
              localStorage.setItem("order-user-cancel", "true");
              CartJS.removeItemById(btn.getAttribute("data-id"));
            }
          });
        }
      }
    );
  }
});

if (!customElements.get("upsell-block")) {
  customElements.define(
    "upsell-block",
    class UpsellBlock extends HTMLElement {
      constructor() {
        super();

        this.querySelector(".up-wrap-out .closeit")?.addEventListener(
          "click",
          (event) => {
            document
              .querySelector(".activeupsell")
              .classList.remove("activeupsell");
            document.body.style.overflow = "";
          }
        );

        this.querySelectorAll([
          ".up-wrap-out .open-cart",
          ".up-wrap-out .closeit",
        ]).forEach((item) =>
          item.addEventListener("click", (event) => {
            document
              .querySelector(".activeupsell")
              ?.classList.remove("activeupsell");
            document.body.style.overflow = "";
            fetchCart();
          })
        );

        this.querySelector(".up-wrap-out .btns.cart")?.addEventListener(
          "click",
          (event) => {
            CartJS.removeItemById(upgradeFromVariantId);
            CartJS.addItem(
              event.target.closest(".cart-btn").getAttribute("data-upsell-id"),
              1
            );
          }
        );
      }
    }
  );
}

if (!customElements.get("cart-item")) {
  customElements.define(
    "cart-item",
    class CartItem extends HTMLElement {
      constructor() {
        super();

        const freeGiftProduct = []

        document.querySelectorAll("#free-products").forEach((item) => {
          freeGiftProduct.push(...JSON.parse(item.innerHTML));
        });

        const productId = this.getAttribute("data-product-id");

        if (!freeGiftProduct.find((item) => item.id === Number(productId)) || Number(this.getAttribute("data-line-price")) !== 0) {
          this.querySelector(".cart_item_remove").style.display = "block";
          this.querySelector(".cart__quantity").style.display = "flex";
        }

        this.querySelector(".cart_item_remove").addEventListener(
          "click",
          (event) => {
            // event.target.classList.add('free-gift-loading')
            document.querySelector("cart-drawer").classList.add("is-loading");

            CartJS.removeItem(event.target.getAttribute("data-line"));
          }
        );

        this.querySelector(".cart__quantity-minus").addEventListener(
          "click",
          () => {
            this.querySelector("input").stepDown();
            this.updateQuantity();
          }
        );
        this.querySelector(".cart__quantity-plus").addEventListener(
          "click",
          () => {
            this.querySelector("input").stepUp();
            this.updateQuantity();
          }
        );
      }

      timeout = null;

      updateQuantity() {
        if (this.timeout) {
          return;
        }

        this.timeout = setTimeout(() => {
          // this.querySelector('.cart_item_remove').classList.add('free-gift-loading')
          document.querySelector("cart-drawer").classList.add("is-loading");
          CartJS.updateItem(
            this.querySelector(".cart_item_remove").getAttribute("data-line"),
            this.querySelector("input").value
          );
          this.timeout = null;
        }, 300);
      }
    }
  );
}

if (!customElements.get("quick-add")) {
  customElements.define(
    "quick-add",
    class QuickAdd extends HTMLElement {
      constructor() {
        super();

        this?.addEventListener("click", (event) => {
          if (this.adding) {
            return;
          }

          this.classList.add("free-gift-loading");
          event.preventDefault();
          event.stopPropagation();

          const formData = new FormData(event.target.closest("form"));

          this.adding = true;

          fetch("/cart/add", {
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/javascript",
            },
            body: formData,
          })
            .then((response) => response.json())
            .then((response) => {
              fetchCart();
              this.adding = false;
            });
        });
      }

      adding = false;

      updateBtn() {
        this.querySelector("button").classList.add("is-added");
        this.querySelector("button").addEventListener(
          "transitionend",
          this.resetButton.bind(this)
        );

        if (window.displayUpgrade) {
          upgradeBlock.classList.add("activeupsell");
          window.addEventListener("transitionend", bodyOverflow);
          window.scrollTo(0, 0);
          window.displayUpgrade = false;
        }

        $(document).off("cart.requestComplete", this.updateBtn.bind(this));
      }

      resetButton() {
        this.querySelector("button").classList.remove("is-loading");
        this.querySelector("button").classList.remove("is-added");
        this.querySelector("button").removeEventListener(
          "transitionend",
          this.resetButton
        );
      }
    }
  );
}

if (!customElements.get("cart-header")) {
  customElements.define(
    "cart-header",
    class CartHeader extends HTMLElement {
      constructor() {
        super();

        this.querySelector(".drawer-cart__close").addEventListener(
          "click",
          (event) => {
            toggleCart();
          }
        );
      }
    }
  );
}

if (!customElements.get("cart-counter")) {
  customElements.define(
    "cart-counter",
    class CartHeader extends HTMLElement {
      constructor() {
        super();

        if (document.querySelector("#cart-json")) {
          this.cartJson = JSON.parse(
            document.querySelector("#cart-json").innerHTML
          );

          let currentCount = Number(this.innerHTML);

          const protectionId = Number(
            this.getAttribute("data-order-protection-id")
          );

          for (const item of this.cartJson.items) {
            if (item.product_id === protectionId) {
              currentCount--;
            }
          }

          this.updateCount(currentCount);
        }
      }

      cartJson = null;

      updateCount(count) {
        if (count === 0) {
          this.style.display = "none";
          return;
        }

        this.innerHTML = count;
        this.style.display = "flex";
      }
    }
  );
}
